var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7536_5157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5524 30.9663C15.6082 30.3284 14.9546 29.3968 14.5977 28.1652L16.7892 27.2621C16.9882 28.0199 17.3355 28.6073 17.8314 29.0242C18.324 29.441 18.924 29.6463 19.6251 29.6463C20.3419 29.6463 20.9577 29.4284 21.4724 28.9926C21.9872 28.5568 22.2462 28.001 22.2462 27.3283C22.2462 26.6399 21.9746 26.0778 21.4314 25.6421C20.8882 25.2063 20.2062 24.9883 19.3914 24.9883H18.1251V22.8189H19.2619C19.963 22.8189 20.5535 22.6294 21.0335 22.2505C21.5135 21.8715 21.7535 21.3536 21.7535 20.6936C21.7535 20.1063 21.5387 19.6389 21.1092 19.2884C20.6798 18.9379 20.1366 18.7611 19.4766 18.7611C18.8323 18.7611 18.3208 18.9316 17.9418 19.2759C17.5629 19.6201 17.2881 20.0432 17.1145 20.5421L14.945 19.639C15.2323 18.8242 15.7598 18.1042 16.5334 17.4821C17.3071 16.86 18.2955 16.5474 19.4955 16.5474C20.3829 16.5474 21.1818 16.7179 21.8892 17.0621C22.5966 17.4064 23.1524 17.8832 23.5535 18.4895C23.9546 19.099 24.1535 19.7811 24.1535 20.539C24.1535 21.3127 23.9672 21.9663 23.5946 22.5032C23.2219 23.04 22.764 23.4506 22.2208 23.738V23.8675C22.9377 24.1675 23.5219 24.6253 23.983 25.2412C24.4408 25.8569 24.6714 26.5928 24.6714 27.4517C24.6714 28.3106 24.4535 29.078 24.0177 29.7506C23.5819 30.4233 22.9787 30.9538 22.2145 31.339C21.4471 31.7243 20.585 31.9201 19.6282 31.9201C18.5198 31.9232 17.4967 31.6043 16.5524 30.9663Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0118 20.0905L27.6054 21.8305L26.4023 20.0052L30.7192 16.8916H32.3739V31.5789H30.0118V20.0905Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6334 36.6316H11.3702L7.75391 41.9601L11.3702 48H36.6334L39.621 41.5738L36.6334 36.6316Z",
    fill: "#00A94B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 0H3.78947C1.69575 0 0 1.69575 0 3.78947V36.6316L5.68425 40.6725L11.3685 36.6316V11.3684H36.6317L40.5206 5.68416L36.6316 0Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.6316V44.2105C0 46.3042 1.69575 48 3.78947 48H11.3684V36.6316H0Z",
    fill: "#00802E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0012 11.3684L42.317 7.71082L36.6328 11.3684V36.6316L41.7449 39.3L48.0012 36.6316V11.3684Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0012 11.3684V3.78947C48.0012 1.69575 46.3055 0 44.2118 0H36.6328V11.3684H48.0012Z",
    fill: "#0067D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6328 48L48.0012 36.6316H36.6328V48Z",
    fill: "#FF4131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7536_5157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.94d9a3caaa0e5d43c0c2fd2d092b1190.svg";
export { ForwardRef as ReactComponent };